import { clearAuthLocalStorage } from 'js/shared/helpers/clearAuthLocalStorage';

import isElectron from './isElectron';
import * as TokenHelpersCookies from './TokenHelper';
import * as TokenHelpersElectron from './TokenHelperElectron';

// Determine the appropriate token helper based on the environment
const getTokenHelpers = () => {
  const isInElectron = isElectron();

  if (isInElectron) {
    return TokenHelpersElectron;
  } else {
    return TokenHelpersCookies;
  }
};

const { setSparkolCookies, getUID, getSparkolToken, getUserInfo, removeSparkolCookies, getRendererAuth } =
  getTokenHelpers();

export {
  setSparkolCookies,
  getUID,
  getSparkolToken,
  getUserInfo,
  removeSparkolCookies,
  getRendererAuth,
  clearAuthLocalStorage
};
